import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { fetchReport } from '../../api'
import Wrapper from './wrapper'
import Header from './Header'
import VendorList from './VendorList'

export default class Connect extends Component {
	state = {
		loading: true,
		vendors: null,
		lead: null
	}

	fetchResults = async () => {
		const res = await fetchReport(this.props.match.params.reportId)
		if(res) {
			const { lead, vendors } = res
			this.setState({vendors, lead, loading: false})
			window.MediaBox('.mediabox')
		}
	}

	componentDidMount() {
		this.fetchResults()
	}

	render() {
		let { loading, vendors, lead } = this.state
		if(loading) {
			return (
				<p>Loading your results...</p>
			)
		} else {
			return (
				<Wrapper>
					<Header firstName={lead.first_name} />
					<VendorList
						resultsId={this.props.match.params.reportId}
						vendors={vendors}
					/>
				</Wrapper>
			)
		}
	}
}

Connect.propTypes = {
	match: PropTypes.object // Used to get the Lead ID
}


// WEBPACK FOOTER //
// ./src/containers/Results/index.js